export default "__VITE_ASSET__937bfb63__"